module.exports = __webpack_public_path__ + "img/Hypoxia-MELA_SpatialResearch.802d09cd.png";